
import {ParentPay} from '~/modules/api/api.types';
import {formatDate} from '~/modules/utils';
import {EntitlementPaidLine} from './EntitlementPaidLine';
import {EntitlementPurchaseTags} from './EntitlementPurchaseTags';

interface InactiveEntitlementProps {
  entitlement: ParentPay.InactiveEntitlementDetail;
}

/**
 * The user's most recently ended entitlement, flagged as inactive
 */
export const InactiveEntitlement = ({
  entitlement,
}: InactiveEntitlementProps) => (
  <div className="mt-3 border-t border-base-200 pt-3 opacity-70">
    <div className="flex items-center gap-2">
      <span className="badge badge-error font-bold">INACTIVE</span>
      <p className="font-medium">{entitlement.entitlement}</p>
      <EntitlementPurchaseTags entitlement={entitlement} />
    </div>
    <EntitlementPaidLine webPurchase={entitlement.webPurchase} />
    <p className="text-sm text-gray-600 break-words">
      <span className="font-bold">Plan:</span> {entitlement.planIdentifier}
    </p>
    {entitlement.billingInterval && (
      <p className="text-sm text-gray-600">
        <span className="font-bold">Billing:</span>{' '}
        {entitlement.billingInterval}
      </p>
    )}
    <p className="text-sm text-gray-600">
      <span className="font-bold">Ended:</span>{' '}
      {formatDate(entitlement.endedAt)}
    </p>
  </div>
);
